import { OrderDocumentLineModel } from './order-document-line.model';

export class OrderDocumentModel {
  public id: string;
  public orderNumber: string;
  public deliveryNumber: string;
  public packingSlipDate: Date | string;
  public createdDate: string;
  public deliveryTerm: string;
  public deliveryMode: string;
  public shipCarrierId: string;
  public shipCarrierServiceId: string;
  public isReadyForDownload?: boolean;
  public documentLines?: OrderDocumentLineModel[];
  public url?: string;
  public name?: string;
  public confirmationNumber: string;
  public isMissingFile?: boolean;
}
